<script>
  import BusinessCardSwiper from "/guidebook/components/FeaturedBusinessCardSwiper.svelte";
  import api from "../api";
  import { BusinessCategory } from "/shared/constants";

  export let businessType;
  export let businessCode;

  const eat_drink = ["restaurant", "bar", "cafe"];

  businessType = eat_drink.includes(businessType)
    ? BusinessCategory.EAT_DRINK
    : businessType;
  const title = {
    activity: "Activities and tours",
    accommodation: "Places to stay",
    eat_drink: "Restaurants, bars and cafes",
  };
  const relatedTypes = {
    activity: [BusinessCategory.ACTIVITY],
    accommodation: [BusinessCategory.ACCOMMODATION],
    eat_drink: [BusinessCategory.EAT_DRINK],
  };
  const icon = {
    activity: "hiking",
    accommodation: "bed",
    eat_drink: "utensils",
  };
</script>

{#await api.apiBusinessNearbyRetrieve(businessCode) then { data }}
  <div class="h5 text-primary subtitle">You may also like</div>

  {#each relatedTypes[businessType] as type}
    <div class="h4 swiper-title font-weight-bolder mb-md-n4">
      <i class={`fa far-${icon[type]} pr-2`} style="color: #3dba3b" />
      {title[type]}
    </div>
    <div class="mb-3">
      {#if data[type]}
        <BusinessCardSwiper businesses={data[type].map((b) => ({ business: b }))} />
      {/if}
    </div>
  {/each}
{/await}
